export default {
  CONTRACTOR_CONFIRM_DATA: null,
  SEND_DATA: null,
  ATTENTED_DOCS: [],
};
